module.exports = __webpack_public_path__ + "static/media/mater-misericordiae-university-hospital.5319a23b.jpg";